// extracted by mini-css-extract-plugin
module.exports = {"qnawrapper":"Fb_f1","qnacontent":"fSMkr","qnaitem":"xFk8c","qnaanswer":"HrVu7"};